/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import axios from 'axios'
import { get } from '../../utils/lodash-utils'

// Probe Details Url
const probeWhiteList = [
  'aws',
  'azure',
  'apache',
  'windows',
  'unix',
  'vmware',
  'docker_monitor',
  'office365',
  'sap_basis',
  'exchange_monitor',
  'ews_response',
  'ldap_response',
  'exchange_monitor',
  'email_response',
  'adevl',
  'ad_server',
  'ad_response',
  'iis',
  'sql_response',
  'mysql',
  'sqlserver',
]
//const probeDetails = `/mcs-ui-app/api/template-summary/Probelist?probeName=${probeWhiteList.join(",")}`


// we have to renew the sid for every request because the alarm api is not under the same namespace


//&& probeListUrl.indexOf("profileCountFlag") === -1
export class ProbesList {
  static fetchProbeDetails(params = {}) {
    let probeListUrl = `/mcs-ui-app/api/_count/probe-details`
    if (process.env.NODE_ENV == "development") {
      return axios.get("http://10.252.25.208:8080/castlemock/mock/rest/project/TK8t3o/application/UXxhjW/_count/probe-details")
    }
    const useEnhancedTemplate = get(params, 'useEnhancedflag', true)
    if (useEnhancedTemplate)
      probeListUrl = params.count ? probeListUrl + "?profileCountFlag=true&filterGroupProfiles=true&useEnhancedTemplates=" + useEnhancedTemplate : probeListUrl + "?profileCountFlag=false&useEnhancedTemplates=" + useEnhancedTemplate;
    else
      probeListUrl = params.count ? probeListUrl + "?profileCountFlag=true&filterGroupProfiles=true" : probeListUrl + "?profileCountFlag=false";

    const categories = params.categories;
    if (typeof categories === 'string') {
      probeListUrl += '&categories=' + categories
    }

    return axios.get(probeListUrl);
  }
}
